import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subscription, interval} from 'rxjs';
import {ProcessingDataSource, DataSourceUploadProgress} from '../models/processing-data-source.model';
@Injectable({
  providedIn: 'root',
})
export class DataSourceUploadProgressService {
  private modalStateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  modalState$: Observable<boolean> = this.modalStateSubject.asObservable();

  private progressSubscription: Subscription[] = [];
  private itemsSubject: BehaviorSubject<ProcessingDataSource[]> = new BehaviorSubject<ProcessingDataSource[]>([]);
  items$: Observable<ProcessingDataSource[]> = this.itemsSubject.asObservable();  // Observable for items
  private completedDataSourceSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  private hasErrorDataSourceSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  completedDataSource$: Observable<string | null> = this.completedDataSourceSubject.asObservable();
  hasErrorDataSource$: Observable<string | null> = this.hasErrorDataSourceSubject.asObservable();
  timeoutInstances: any[] = [];
  isActive: boolean = true;

  constructor() {}

  openModal() {
    this.modalStateSubject.next(true);
    // this.load();
  }

  forceOpenModal() {
    this.modalStateSubject.next(true);
    // this.load();
  }

  closeModal() {
    this.modalStateSubject.next(false);
  }

  updateCompletedDataSourceItem(item: DataSourceUploadProgress) {
    this.completedDataSourceSubject.next(item.dataSourceId);
  }

  private shouldOpenModal = true;

  // setShouldOpenModal(value: boolean): void {
  //   this.shouldOpenModal = value;
  // }

  // getShouldOpenModal(): boolean {
  //   return this.shouldOpenModal;
  // }

  /**
   * calls the api and starts listening to the service
   */
  load() {
    // this.dataSourceFacade.loadProcessingDataSources();
    // this.start();
  }

  /**
   * starts listening to the service
   */
  start() {
    // this.toggle(true)
    // this.destroySubscriptions()
    // this.progressSubscription.push(this.dataSourceFacade.getProcessingDataSources$().subscribe((items) => {
    //   if (items && items.length) {
    //     const currentExpandedStates = this.itemsSubject.value.map((item) => item.isExpanded);
    //     const currentRedBoxExpandedStates = this.itemsSubject.value.map((item) => item?.isRedBoxExpanded);
    //     this.itemsSubject.next(items);
    //     this.itemsSubject.value.forEach((item, index) => {
    //       item.isExpanded = currentExpandedStates[index] ?? false;
    //       item.isRedBoxExpanded = currentRedBoxExpandedStates[index] ?? false;
    //       if (item.progressStatus === 'Completed') {
    //         this.completedDataSourceSubject.next(item.id);
    //       }
    //       if (item.progressStatus === 'HasError') {
    //         this.hasErrorDataSourceSubject.next(item.id);
    //       }
    //     });
    //     const inProgressItems = this.itemsSubject?.value?.filter(item => item.progressStatus === 'InProgress')
    //     if (inProgressItems.length) {
    //       this.timeoutInstances.push(setTimeout(() => {
    //         this.dataSourceFacade.loadProcessingDataSources();
    //       }, this.getSmallestInterval(inProgressItems)))
    //     } else {
    //       this.stop()
    //     }
    //   } else {
    //     this.itemsSubject.next([]);
    //   }
    // }));
  }

  /**
   * stops the timer
   */
  stop() {
    this.toggle(false);
    this.destroySubscriptions()
  }

  destroySubscriptions() {
    this.timeoutInstances.forEach(item => {
      clearTimeout(item)
    });
    this.progressSubscription.forEach((item: any) => {
      item.unsubscribe();
    });
  }

  /**
   * resets timers and will close the dialog
   */
  reset() {
    this.stop()
    this.closeModal()
  }

  getSmallestInterval(items: ProcessingDataSource[]): number {
    if (!items || items.length === 0) return 0;
    const intervals = Math.min(...items.map((item) => item.processInterval));
    return (intervals< 1 ? 60000 : (intervals*30000));
  }

  getModalState(): Observable<boolean> {
    return this.modalState$;
  }

  /**
   * toggles service call
   * @param isActive
   */
  toggle(isActive: boolean) {
    this.isActive = isActive;
  }

  /**
   * reloads service call
   */
  reload() {
    // this.toggle(true);
    // this.load()
  }
}
